import { registerCondition } from 'core/forms';

const isNotCatalogActivity = ({ model }) => ({
  hasCondition: model.source_content_type !== 'catalog_activity',
  condition: null,
});

registerCondition('isNotCatalogActivity', isNotCatalogActivity);

export default isNotCatalogActivity;
